import moment from "moment";

export default function(date: Date): string {
  return moment(date, "YYYY-MM-DD HH:mm").format("YYYY.MM.DD HH:mm");
}
